import { Whisper, Popover, Checkbox, CheckboxGroup, IconButton } from 'rsuite';
import GearIcon from '@rsuite/icons/Gear';

// Cloudscape-style column show/hide control: a bare gear IconButton that opens a
// popover of checkboxes, replacing the inline "Columns" CheckPicker. Shared by
// DevicesTable and FaultsTable.
//   data:     [{ label, value }] of the toggleable columns
//   value:    array of currently-visible column ids
//   onChange: (nextValue) => void  (rsuite CheckboxGroup passes the new array)
export function ColumnsMenu({ data, value, onChange, label = 'Choose columns' }) {
  const speaker = (
    <Popover>
      <CheckboxGroup value={value} onChange={onChange}>
        {data.map((col) => (
          <Checkbox key={col.value} value={col.value}>
            {col.label}
          </Checkbox>
        ))}
      </CheckboxGroup>
    </Popover>
  );
  return (
    <Whisper trigger="click" placement="bottomEnd" speaker={speaker}>
      <IconButton icon={<GearIcon />} appearance="subtle" size="sm" aria-label={label} />
    </Whisper>
  );
}
